import React from "react";
import styles from "./vertical-spacer.module.css";
import { isCssLength } from "./css-length";
import { withSafeRender } from "../../atoms/safe-render";

/**
 * Vertical Spacer — prod's dtv-vertical-spacer on the DDS grid: one field per
 * grid tier instead of prod's five MUI tiers (defaults live in the CSS module).
 */

/* Only valid sizes become custom properties: a set-but-invalid one makes the
   var() invalid and the gap 0, where prod's MUI would drop it. */
const lengthOrUnset = (value?: string): string | undefined => {
  const trimmed = value?.trim?.();
  return trimmed && isCssLength(trimmed) ? trimmed : undefined;
};

export interface VerticalSpacerProps {
  /** Space below 735px, as a CSS length ("20px"). Default 20px. */
  mobile_space?: string;
  /** Space from 735px. Default 32px. */
  tablet_space?: string;
  /** Space from 1280px. Default 100px. */
  desktop_space?: string;
  /** Space from 1732px. Default 180px. */
  wide_space?: string;
  /** Added as a class name, as prod does. */
  id?: string;
}

function VerticalSpacerImpl({
  mobile_space: mobileSpace,
  tablet_space: tabletSpace,
  desktop_space: desktopSpace,
  wide_space: wideSpace,
  id
}: VerticalSpacerProps) {
  // React omits an undefined style key, so the CSS fallback takes over.
  const style = {
    "--vertical-spacer-mobile": lengthOrUnset(mobileSpace),
    "--vertical-spacer-tablet": lengthOrUnset(tabletSpace),
    "--vertical-spacer-desktop": lengthOrUnset(desktopSpace),
    "--vertical-spacer-wide": lengthOrUnset(wideSpace)
  } as React.CSSProperties;

  return (
    <div
      aria-hidden="true"
      className={[styles.spacer, id].filter(Boolean).join(" ")}
      style={style}
    />
  );
}
export const VerticalSpacer = withSafeRender(VerticalSpacerImpl, "VerticalSpacer");

export default VerticalSpacer;
